import { render, staticRenderFns } from "./MigrationsView.vue?vue&type=template&id=4e916d0a&"
import script from "./MigrationsView.vue?vue&type=script&lang=js&"
export * from "./MigrationsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e916d0a')) {
      api.createRecord('4e916d0a', component.options)
    } else {
      api.reload('4e916d0a', component.options)
    }
    module.hot.accept("./MigrationsView.vue?vue&type=template&id=4e916d0a&", function () {
      api.rerender('4e916d0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/migrations/MigrationsView.vue"
export default component.exports